import React from 'react';

const CreatedBy = () => {
    return <p>created by <a target="_blank" href="https://github.com/betterhell" rel="noreferrer">betterHell</a></p>
};

export default CreatedBy;